//import Libraries
import React, {Component} from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

//import Components
import AccountTable from './AccountTable';

//import Styles

class AccountPagination extends Component {

    constructor(props) {
        super(props);

        const {accounts} = props;

        const viewCount = 6;
        const totalPage = Math.ceil(accounts.length / viewCount);

        this.state = {
            viewCount,
            totalPage,
            viewingPage : 0 
        }
    }

    handleOnViewChange = (page) => {
        this.setState({
            viewingPage : page
        })
    }

    renderPages = () => {
        const { viewingPage, viewCount, totalPage } = this.state;

        let pages = [];
        pages.push(
            <PaginationItem disabled={viewingPage === 0 ? true : false} key="prev">
                <PaginationLink onClick={() => this.props.onViewingPageChange(viewingPage - 1 )} previous />
            </PaginationItem>
        );
        for(let i = 0; i < totalPage; ++i) {
            pages.push(
                <PaginationItem active={viewingPage === i ? true : false} key={i}>
                    <PaginationLink name={i} onClick={() => this.handleOnViewChange(i)}>
                        {i + 1}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        pages.push(
            <PaginationItem disabled={viewingPage === totalPage - 1 ? true : false} key="next">
                <PaginationLink onClick={() => this.props.onViewingPageChange(viewingPage + 1)} next />
            </PaginationItem>
        );
        return pages;
    }

    render() {
        const {accounts} = this.props;
        const { viewingPage, viewCount, totalPage } = this.state;

        const startIndex = viewingPage * viewCount;
        const endIndex = (viewingPage * viewCount) + (viewCount - 1);

        const viewingAccounts = accounts.filter((account, index) => {
            return (index >= startIndex) && (index <= endIndex);
        });

        return (
            <div>
                <div>
                    <AccountTable 
                        accounts={viewingAccounts}
                    />
                </div>
                <div className="d-flex justify-content-center col">
                    <Pagination aria-label="Page navigation example">
                        {
                            this.renderPages()
                        }
                    </Pagination>
                </div>
            </div>
        );
    }
}

export default AccountPagination;




// WEBPACK FOOTER //
// ./src/pages/Admin/AccountManager/AccountPagination.js